module.exports = __webpack_public_path__ + "img/984ac5f.png";